<script lang="ts">
  import { createContext } from 'reka-ui'
  import type { UserRoleAssignmentsService } from '@gat-ship/types/injection-keys'

  const [useTenantUserRoleAssignments, provideTenantUserRoleAssignments] =
    createContext<UserRoleAssignmentsService>(
      'tenant-user-role-assignments-provider'
    )

  export { useTenantUserRoleAssignments }
</script>

<script setup lang="ts">
  import { inject, provide, watch } from 'vue'
  import { useUserRoleAssignments } from '@gat-ship/access-control'
  import { userRoleAssignmentsKey } from '@gat-ship/types/injection-keys'

  const props = defineProps<{
    databaseId?: string
    userId: string
  }>()

  watch(
    () => props.databaseId,
    (newVal) => {
      if (newVal) {
        dataSource.fetchRoleAssignments({
          userId: props.userId,
          forceFetch: true
        })
      }
    },
    {
      immediate: true
    }
  )

  const dataSource =
    inject(userRoleAssignmentsKey, undefined) ?? useUserRoleAssignments()
  provide(userRoleAssignmentsKey, dataSource)
  provideTenantUserRoleAssignments(dataSource)
</script>

<template>
  <slot />
</template>
